import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL_SANDBOX, NEW_ARRIVAL_NEAR_YOU } from '../../../Constants/Config';

const initialState = {
  loading: false,
  newArrivalList: [],
  error: '',
  totalPages: 0,
  hasMore: true,
};

export const fetchNewArrivalLists = createAsyncThunk(
  'newArrivalList/fetchNewArrivalLists',
  async ({ lat, long }, { rejectWithValue }) => {
    try {
      const formData = new FormData();

        formData.append('lat', lat || '');
      formData.append('long', long || '');
      const response = await axios.post(
        `${BASE_URL_SANDBOX}${NEW_ARRIVAL_NEAR_YOU}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.status === 200 && response.data && response.data.data) {
        return {
          newArrivalList: response.data.data,
          totalPages: response?.data?.totalPages,
        };
      } else {
        return { newArrivalList: [], totalPages: 0, hasMore: false };
      }
    } catch (e) {
      return rejectWithValue(e.message);
    }
  }
);

const newArrivalSlice = createSlice({
  name: 'newArrivalList',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchNewArrivalLists.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNewArrivalLists.fulfilled, (state, action) => {
        state.loading = false;
        state.newArrivalList = action.payload?.newArrivalList;
        state.totalPages = action.payload?.totalPages || 0;
        state.error = '';
      })
      .addCase(fetchNewArrivalLists.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch  New Arrivals Near You';
        state.hasMore = false;
      });
  },
});

export default newArrivalSlice.reducer;